module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/email-1ea74567cd5e3ef316e812b172184ba2.svg";